import { AGENT_EDIT_CHROME_DATA } from '@atlaskit/editor-common/collab-agent-edit-chrome';
import type { AgentEditChromeData } from '@atlaskit/editor-common/collab-agent-edit-chrome';
import type { EditorCommand } from '@atlaskit/editor-common/types';

import { agentEditChromePluginKey } from './plugin-key';
import type { AgentEditChromeAction } from './types';

export const showAgentEditChrome =
	(data: AgentEditChromeData): EditorCommand =>
	({ tr }) =>
		tr.setMeta(AGENT_EDIT_CHROME_DATA, data);

export const removeAgentEditChrome =
	(revision: number): EditorCommand =>
	({ tr }) =>
		tr.setMeta(agentEditChromePluginKey, {
			revision,
			type: 'REMOVE',
		} satisfies AgentEditChromeAction);
